import { Inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import { PlatformType } from '../types/muni-environment';

@Injectable()
// This service is a placeholder for URL-related functionalities.
// It can be extended in the future to include methods for URL manipulation,
export class URLService {
  private readonly platform: PlatformType;
  constructor(
    private router: Router,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.platform =
      (config.params.platform as PlatformType) || PlatformType.polaris;
  }
  public getUrlTree(data, selectedWeek?: string): UrlTree {
    let urlTree: UrlTree;

    if (this.platform === PlatformType.buyside) {
      urlTree = this.getUrlTreeWithParams(data, selectedWeek);
    } else {
      urlTree = this.getUrlTreeForSellSide(data);
    }
    return urlTree;
  }

  public getUrlTreeWithParams(
    data: any,
    selectedWeek: string,
    fragment: string = `muni-deals/${data.id}`
  ) {
    return this.router.createUrlTree(['/'], {
      queryParams: { weekOf: selectedWeek },
      fragment
    });
  }

  public getUrlTreeForSellSide(data: any) {
    return this.router.createUrlTree(['munis', 'deals', data.id]);
  }

  public getSerializedUrl(urlTree: any) {
    // Serialize the URL to a string
    const subUrl = this.router.serializeUrl(urlTree);
    // Get the full URL by appending the sub-URL to the current domain
    return `${window.location.origin}${subUrl}`;
  }
}
